import { List } from "immutable"
import selectModels from "./models"

export default function selectModel(state, engine, model) {
  const models = selectModels(state)
  return models && models.get(List([engine.name, model.name]))
}
